module.exports = __webpack_public_path__ + "static/media/knc.6ef20212.png";